import React, { Component } from 'react';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      core: true,
      suburban: false,
      county: false,
      city: false,
      geoJsonDistricts: null
    };
  }

  componentDidMount() {
    this.getProvinceAndGeoJson();
  }

  setSelectedDistricts() {
    const { core, suburban, county, city, geoJsonDistricts } = this.state;
    const { districts } = this.props;

    let displayName = this.generateDisplayName();
    let displayChineseName = this.generateDisplayChineseName();
    let selectedDistricts = [];

    districts.forEach((district) => {
      let districtType = district.attributes["subarea-type"];

      if(!geoJsonDistricts || this.mapHasDistrict(district)) {
        if(core && districtType === "Core District") {
          selectedDistricts.push(district);
        } else if(suburban && districtType === "Suburban District") {
          selectedDistricts.push(district);
        } else if(city && districtType === "City") {
          selectedDistricts.push(district);
        } else if(county && !["Core District", "Suburban District", "City"].includes(districtType)) {
          selectedDistricts.push(district);
        }
      }
    });

    this.props.updatePrefecture({
      displayName: displayName,
      displayChineseName: displayChineseName,
      currentDistricts: selectedDistricts
    });
  }

  mapHasDistrict(district) {
    const { geoJsonDistricts } = this.state;
    let hasDistrict = false;

    geoJsonDistricts.forEach((geoJsonDistrict) => {
      if(geoJsonDistrict.properties.chineseName === district.attributes["chinese-name"])
        hasDistrict = true;
    });

    return hasDistrict;
  }

  getProvinceAndGeoJson() {
    const { prefecture } = this.props;

    if(prefecture) {
      fetch(prefecture.relationships.province.links.related).then((resp) => resp.json())
        .then((respJson) => {
          const province = respJson.data;
          fetch(`/geographies/prefectures/${province.attributes.name}/${prefecture.attributes.name}.json`)
            .then((resp) => resp.json())
            .then((respJson) => {
              this.setState({ geoJsonDistricts: respJson.objects[prefecture.attributes.name].geometries });
            });
        });
    }
  }

  generateDisplayName() {
    const { core, suburban, county, city } = this.state;
    let displayName = "";

    let labels = [
      { name: "Core Districts", set: core },
      { name: "Suburban Districts", set: suburban },
      { name: "Counties", set: county },
      { name: "Sub-Cities", set: city }
    ];

    for(let label of labels) {
      if(label.set) {
        displayName = displayName.length === 0 ? label.name : displayName + ", " + label.name;
      }
    }

    return displayName;
  }

  generateDisplayChineseName() {
    const { core, suburban, county, city } = this.state;
    let displayName = "";

    let labels = [
      { name: "城区", set: core },
      { name: "郊区", set: suburban },
      { name: "县", set: county },
      { name: "县级市", set: city }
    ];

    for(let label of labels) {
      if(label.set) {
        displayName = displayName.length === 0 ? label.name : displayName + ", " + label.name;
      }
    }

    return displayName;
  }

  render() {
    const { core, suburban, county, city } = this.state;

    return (
      <div className="pref-filter-bar">
        <span className="pref-filter-label">View:</span>
        <button
          className={`pref-filter-pill pref-filter-core${core ? ' active' : ''}`}
          onClick={() => this.setState({ core: !core })}>
          Core Districts
        </button>
        <button
          className={`pref-filter-pill pref-filter-suburban${suburban ? ' active' : ''}`}
          onClick={() => this.setState({ suburban: !suburban })}>
          Suburban
        </button>
        <button
          className={`pref-filter-pill pref-filter-county${county ? ' active' : ''}`}
          onClick={() => this.setState({ county: !county })}>
          Counties
        </button>
        <button
          className={`pref-filter-pill pref-filter-city${city ? ' active' : ''}`}
          onClick={() => this.setState({ city: !city })}>
          Sub-Cities
        </button>
        <button
          className="btn btn-primary pref-filter-apply"
          onClick={this.setSelectedDistricts.bind(this)}>
          Apply
        </button>
      </div>
    );
  }
}

export default Filter;
